<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  agents: { type: Array, default: () => [] },
  assigning: { type: Boolean, default: false },
  loadingAgents: { type: Boolean, default: false },
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'confirm']);
const { t } = useI18n();
const responsibleUserId = ref('');

watch(
  () => props.show,
  value => {
    if (value) responsibleUserId.value = '';
  }
);
const confirm = () => {
  if (responsibleUserId.value) emit('confirm', responsibleUserId.value);
};
</script>

<template>
  <LaisModal
    :show="show"
    :title="t('POST_SALE.DETAIL.ASSIGN_TITLE')"
    @close="emit('close')"
  >
    <p class="mb-4 text-sm text-lais-text-body">
      {{ t('POST_SALE.DETAIL.ASSIGN_DESCRIPTION') }}
    </p>
    <select
      v-model="responsibleUserId"
      class="min-h-10 w-full rounded-lais border border-lais-border bg-white px-3 text-sm"
      :disabled="loadingAgents || assigning"
    >
      <option value="">{{ t('POST_SALE.DETAIL.ASSIGN_PLACEHOLDER') }}</option>
      <option v-for="agent in agents" :key="agent.id" :value="agent.id">
        {{ agent.name }}
      </option>
    </select>
    <template #footer>
      <div class="flex justify-end gap-2">
        <LaisPrimaryButton variant="ghost" @click="emit('close')">
          {{ t('POST_SALE.ACTIONS.CANCEL') }}
        </LaisPrimaryButton>
        <LaisPrimaryButton
          :disabled="!responsibleUserId"
          :is-loading="assigning"
          @click="confirm"
        >
          {{ t('POST_SALE.ACTIONS.ASSIGN') }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisModal>
</template>
